
import links from "@/config/links";
import DefaultHeaderComponent from "../common/DefaultHeaderComponent.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    DefaultHeaderComponent,
  },
  data() {
    return {
      links,
    };
  },
});
